function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/@emotion/memoize/dist/memoize.esm.js
// module id = 1017
// module chunks = 0 2 4 5 7 11 12